import { useEffect, useState } from 'react';
import { useLocation } from 'react-use';
import LoaderModal from '../../../components/common/LoaderModal';

const CertificateTemplate = () => {
  const location = useLocation();
  const { id } = location.state.usr || {};
  // const { id } = useParams();
  const [staticpdfUrl, setStaticpdfUrl] = useState('');

  const imagesArray = [
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/عامGeneral.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/الشفاءHealing.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/العملGettingJob.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/الوالدينParents.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/مواليدBirths.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/التخرجGraduation.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/الزواجMarriage.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/النجاحSuccess.pdf` },
    { src: `${window.location.origin}/assets/images/certificates/certificatePdf/العيدEid.pdf` },
  ];

  useEffect(() => {
    localStorage.setItem('isHome', true);
    setStaticpdfUrl(imagesArray[id - 1]?.src);
  }, []);

  return (
    <div>
      {staticpdfUrl != '' ? (
        <object
          data={staticpdfUrl}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{ minHeight: '100vh', marginTop: '90px' }}
        >
          <p>
            It seems your browser does not support viewing PDFs directly.
            <a
              className="text-center text-customgreen mt-5"
              href={staticpdfUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              click here to download the PDF file.
            </a>
          </p>
        </object>
      ) : (
        <LoaderModal className="pt-10" />
      )}
    </div>
  );
};

export default CertificateTemplate;
